/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Loading_DetailsInputs */

const cs_property_registry_loading_details = /** @type {(inputs: Property_Registry_Loading_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítám parcely a jednotky…`)
};

const en_property_registry_loading_details = /** @type {(inputs: Property_Registry_Loading_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading parcels and units…`)
};

/**
* | output |
* | --- |
* | "Loading parcels and units…" |
*
* @param {Property_Registry_Loading_DetailsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_loading_details = /** @type {((inputs?: Property_Registry_Loading_DetailsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Loading_DetailsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_loading_details(inputs)
	return cs_property_registry_loading_details(inputs)
});